import { X } from 'lucide-react';

import { CustomInput, CustomSelectPicker, Loader } from '#/common/components';
import { MAX_LENGTH_LIMIT } from '#/utils/constants';
import { capitalizeText } from '#/utils/helperFunctions';
import { RenderFileList, useStickyButtonWidget } from '..';

function StickyButtonPreview() {
  const {
    formik,
    stickyBtnDetail,
    handlePreviewToggle,
    handleFileChange,
    handleTelInputChange,
    isUploadFileLoading,
    isFieldSubmit,
    handleSelectChange,
    uploadedFiles,
    isProcessingFiles,
    handleRemoveFile,
    fileRef,
    isLeadSubmitLoading,
  } = useStickyButtonWidget() || {};

  const {
    backgroundColor = '',
    labelColor = '',
    additionalNoteEnabled,
    additionalNoteText,
    privacyPolicyDocument,
    additionalNoteLinkText,
    lead = {},
    position,
  } = stickyBtnDetail?.data || {};

  const { values, errors, touched, handleChange, submitForm } = formik;

  const handleClose = () => {
    window.parent.postMessage({ action: 'close' }, '*');
    handlePreviewToggle();
  };

  const isLoading = isUploadFileLoading || isProcessingFiles || isLeadSubmitLoading;

  return (
    position && (
      <div className="lead-box" style={{ [position]: 0 }}>
        <div className="box">
          <h4>{lead?.name}</h4>
          <span className="close-icon" onClick={handleClose}>
            <X />
          </span>
          <div className="fields">
            {lead?.fields?.map(field => {
              if (!field) return null;

              const { label, type, fieldItems } = field || {};
              const fieldType = type?.toLowerCase();

              const isFileField = fieldType === 'upload';
              const isNumberField = fieldType === 'number';
              const isDropDownField = fieldType === 'dropdown';

              return (
                <>
                  {isDropDownField ? (
                    <CustomSelectPicker
                      name={label}
                      value={fieldItems.find(v => v.label === values[label])}
                      onChange={value => handleSelectChange(label, value?.label)}
                      options={fieldItems}
                      placeholder={capitalizeText(label) || 'Select a option'}
                      isError={errors[label] && touched[label]}
                      errorMessage={errors[label]}
                    />
                  ) : (
                    <div className="field-wrapper">
                      <CustomInput
                        key={isFileField ? (isFieldSubmit ? 'uploaded' : 'empty') : label}
                        type={isFileField ? 'file' : isNumberField ? 'tel' : fieldType}
                        name={label}
                        placeholder={isFileField && isProcessingFiles ? 'Uploading...' : capitalizeText(label)}
                        multiple={isFileField}
                        ref={fileRef}
                        onChange={
                          isFileField
                            ? handleFileChange(label)
                            : isNumberField
                              ? handleTelInputChange(label)
                              : handleChange
                        }
                        isError={errors[label] && touched[label]}
                        errorMessage={errors[label]}
                        value={isFileField ? undefined : values[label] || ''}
                        maxLength={MAX_LENGTH_LIMIT}
                        onKeyPress={
                          isNumberField
                            ? e => {
                              if (!/\d/.test(e.key)) {
                                e.preventDefault();
                              }
                            }
                            : undefined
                        }
                        disabled={isFileField && isProcessingFiles}
                      />
                      {isFileField && uploadedFiles[label] && (
                        <RenderFileList
                          files={uploadedFiles[label]}
                          fieldName={label}
                          handleRemoveFile={handleRemoveFile}
                        />
                      )}
                    </div>
                  )}
                </>
              );
            })}
            <button
              className="btn btn-primary"
              style={{ backgroundColor: backgroundColor, color: labelColor }}
              disabled={isLoading}
              onClick={submitForm}
            >
              {isLeadSubmitLoading ? <Loader /> : lead?.submitButtonText}
            </button>
          </div>
        </div>
        {additionalNoteEnabled && (
          <div className="additional-note-wrapper">
            <span>
              {additionalNoteText}
              <a href={privacyPolicyDocument?.file} target="_blank" download>
                {additionalNoteLinkText}
              </a>
            </span>
          </div>
        )}
        <p className="powered-by">
          Powered by{' '}
          <a href="https://booosted.fi" target="_blank">
            Booosted.fi
          </a>
        </p>
      </div>
    )
  );
}

export default StickyButtonPreview;
